import gql from 'graphql-tag';

export const UPDATE_AFTERMARKET_PRODUCTS = gql`
  mutation UpdateAftermarketProduct($input: UpdateAftermarketProductInput!) {
    update: updateAftermarketProduct(input: $input) {
      success
      aftermarketProductId
    }
  }
`;
